import { render, staticRenderFns } from "./SurveyAverageRating.vue?vue&type=template&id=4507c3a4"
import script from "./SurveyAverageRating.vue?vue&type=script&lang=js"
export * from "./SurveyAverageRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports